$(document).ready(function () {
	$('[data-trigger="catalog-filter-form"]').on('change', function () {
		$("#catalog-filter-form").submit();
	});

	$("#catalog-filter-form").submit(function () {
		let type = $(".catalog-desktop-filters").is(':visible');

		// desktop
		if (type) {
			$container = $('.catalog-mobile-filters');
		}
		// mobile
		else {
			$container = $('.catalog-desktop-filters');
		}

		$container.find('input, select').attr('disabled', 'disabled');
	});
});